import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function MonitorPassword({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M20.9999 12V14.42C20.9999 15.83 19.8399 16.99 18.4199 16.99C18.4099 16.99 18.4099 16.99 18.4099 16.99H5.5499C4.1299 16.99 2.9699 15.83 2.9699 14.41C2.9599 14.4 2.9599 14.4 2.9699 14.4V5.54C2.9599 4.12 4.1199 2.96 5.5399 2.96M5.5399 2.96C5.5399 2.95 5.5399 2.95 5.5399 2.96ZM5.5399 2.96H5.9599M13.9999 17L14.4999 21M9.9999 17L9.4999 21M8.1399 21H15.8599M12.4949 5.5V5.49L12.4849 5.48H12.4749M15.4949 5.5V5.49L15.4849 5.48H15.4749M18.4899 5.5V5.49L18.4799 5.48H18.4699M20.9999 13.5H2.9999M10.9999 2H19.9999C21.1045 2 21.9999 2.89543 21.9999 4V7C21.9999 8.10457 21.1045 9 19.9999 9H10.9999C9.89533 9 8.9999 8.10457 8.9999 7V4C8.9999 2.89543 9.89533 2 10.9999 2Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default MonitorPassword;